
'use strict'

import NewsDraggableList from "../../utils/NewsDraggableList";
import OurTeamDetailContact from "./OurTeamDetailContact";
import App from "../../App";

class OurTeamDetail{
    constructor(){
        this.main = document.getElementById('our_team_detail');

        this._data = JSON.parse(this.main.getAttribute('data-data'));

        this._teamMemberPosition = this.main.querySelector('.team_member_position');
        this._teamMemberName = this.main.querySelector('.team_member_name');
        this._teamMemberBio = this.main.querySelector('.team_member_bio');
        this._teamMemberEmail = this.main.querySelector('.team_member_email');
        this._teamMemberMobile = this.main.querySelector('.team_member_mobile');
        this._teamMemberLinkedin = this.main.querySelector('.team_member_linkedin');
        this._teamMemberPhone = this.main.querySelector('.team_member_phone');
        this._teamMemberVCard = this.main.querySelector('.team_member_vcard');
        this._teamMemberCV = this.main.querySelector('.team_member_cv');
        this._teamMemberCardImageActual = this.main.querySelector('.team_member_card_image_actual');
        this._teamMemberCardImageNew = this.main.querySelector('.team_member_card_image_new');
        this._teamMemberCardPosition = this.main.querySelector('.team_member_card_position');
        this._teamMemberCardName = this.main.querySelector('.team_member_card_name');
        
        
        this._nextBtn = this.main.querySelector('.next_btn');
        if(this._data.next_slug === null){
            this._nextBtn.style.display = 'none';
        }

        this._prevBtn = this.main.querySelector('.prev_btn');
        if(this._data.prev_slug === null){
            this._prevBtn.style.display = 'none';
        }
        
        this._holderAreas = this.main.querySelector('.holder_areas');
        
        this._newsMemberName = this.main.querySelector('.news_team_member_name');
        this._newsDraggable = new NewsDraggableList(document.getElementById('our_team_detail_news'));

        this._contact = new OurTeamDetailContact();
        
        this._timeout = null;

        this._setData(this._data);
        
        this._nextBtn.addEventListener('click', this._onClickNextBtn.bind(this));
        this._prevBtn.addEventListener('click', this._onClickPrevBtn.bind(this));
        window.addEventListener('popstate', this._onSlugChanged.bind(this));
    }

    _setData(data){
        clearTimeout(this._timeout);
        
        this.main.classList.remove('page--professional-detail-out');
        this.main.classList.add('page--professional-detail-out');

        this._teamMemberCardImageNew.style.backgroundImage = `url(${App.filesPath + data.image}?version=${App.version})`;
        this._teamMemberCardImageActual.classList.add('bg__img--out');

        this._timeout = setTimeout(()=>{
            this._teamMemberPosition.innerHTML = data.position;
            this._teamMemberName.innerHTML = `${data.first_name} ${data.last_name}`;
            this._teamMemberBio.innerHTML = data.bio;

            this._teamMemberEmail.parentElement.style.setProperty("display", "none", "important");
            this._teamMemberMobile.parentElement.style.setProperty("display", "none", "important");
            this._teamMemberLinkedin.parentElement.style.setProperty("display", "none", "important");
            this._teamMemberPhone.parentElement.style.setProperty("display", "none", "important");
            this._teamMemberVCard.parentElement.style.setProperty("display", "none", "important");
            this._teamMemberCV.parentElement.style.setProperty("display", "none", "important");
            
            if(data.email !== ''){
                this._teamMemberEmail.innerHTML = data.email;
                this._teamMemberEmail.parentElement.setAttribute('href', `mailto:${data.email}`);
                this._teamMemberEmail.parentElement.style.setProperty("display", "flex", "important");
            }
            
            if(data.mobile !== ''){
                this._teamMemberMobile.innerHTML = data.mobile;
                this._teamMemberMobile.parentElement.setAttribute('href', `tel:${data.mobile}`);
                this._teamMemberMobile.parentElement.style.setProperty("display", "flex", "important");
            }
            
            if(data.linkedin !== ''){
                this._teamMemberLinkedin.innerHTML = data.linkedin;
                this._teamMemberLinkedin.parentElement.setAttribute('href', `https://www.${data.linkedin}`);
                this._teamMemberLinkedin.parentElement.style.setProperty("display", "flex", "important");
            }

            if(data.phone !== ''){
                this._teamMemberPhone.innerHTML = data.phone;
                this._teamMemberPhone.parentElement.setAttribute('href', `tel:${data.phone}`);
                this._teamMemberPhone.parentElement.style.setProperty("display", "flex", "important");
            }

            if(data.vcard !== null && data.vcard !== ''){
                this._teamMemberVCard.setAttribute('href', App.filesPath + data.vcard);
                this._teamMemberVCard.parentElement.style.setProperty("display", "flex", "important");
            }

            //console.log('data.cv:', data.cv);
            if(data.cv !== null && data.cv !== ''){
                this._teamMemberCV.setAttribute('href', App.filesPath + data.cv)
                this._teamMemberCV.parentElement.style.setProperty("display", "flex", "important");
            }
            
            this._teamMemberCardName = `${data.first_name} ${data.last_name}`;

            this._teamMemberCardImageActual.style.backgroundImage = `url(${App.filesPath + data.image}?version=${App.version})`;
            setTimeout(()=>{
                this._teamMemberCardImageActual.classList.remove('bg__img--out');
            }, 0);    
                        
            this._holderAreas.innerHTML = '';
            if(data.areas.length === 0){
                this._holderAreas.parentNode.style.setProperty("display", "none", "important");
            } else {
                this._holderAreas.parentNode.style.setProperty("display", "block", "important");
                data.areas.forEach((area)=>{
                    this._holderAreas.insertAdjacentHTML('beforeend', /*html*/`<div class="col-12 col-sm-auto mt-1"><a href="${App.baseUrl + App.sitemap.areas_detail.slug + area.slug}" class="link">${area.name}</a></div>`);
                });
            }

            this._newsMemberName.innerHTML = data.first_name;

            //console.log('data.news:', data.news);
            document.getElementById('our_team_detail_news').querySelector('.holder_items').innerHTML = "";
            //console.log('Elimino el listado');
            if (data.news.length === 0){
                document.getElementById('our_team_detail_news').style.setProperty("display", "none", "important");
            } else {
                document.getElementById('our_team_detail_news').style.setProperty("display", "block", "important");
                this._newsDraggable.set(data.news);
            }

            this._contact.set(data);
            
            
            this.main.classList.remove('page--professional-detail-out');
                      

        }, 500)

    }

    _onClickNextBtn(e){
        window.history.pushState({slug: this._data.next_slug}, this._data.next_slug, this._data.next_slug);
        this._getTeamMember(this._data.next_slug);
    }

    _onClickPrevBtn(e){
        window.history.pushState({slug: this._data.prev_slug}, this._data.prev_slug, this._data.prev_slug);
        this._getTeamMember(this._data.prev_slug);
    }

    _onSlugChanged(e){
        this._getTeamMember(e.state.slug);       
    }

    _getTeamMember(slug){
        fetch(`${App.baseUrl}our-team/detail/${slug}?lang=${App.lang}`, {
            headers: {
                'Cache-Control': 'no-cache'
            }
        })
        .then(response => response.json())
        .then((response)=>{
            if(!response.error){
                this._data = response.data;

                if(this._data.next_slug === null){
                    this._nextBtn.style.display = 'none';
                } else {
                    this._nextBtn.style.display = 'block';
                }

                if(this._data.prev_slug === null){
                    this._prevBtn.style.display = 'none';
                } else {
                    this._prevBtn.style.display = 'block';
                }
                
                this._setData(this._data);
            }

        })
    }
}

export default OurTeamDetail;